import { render, staticRenderFns } from "./maintainpage.vue?vue&type=template&id=df77fd54&"
import script from "./maintainpage.vue?vue&type=script&lang=js&"
export * from "./maintainpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports